import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ResponseHeadersService} from './response-headers.service';
import {ResponseHeadersInterceptor} from './response-headers.interceptor';


@NgModule({
    imports  : [
        HttpClientModule,
        CommonModule,
        TranslateModule
    ],
    providers: [
        ResponseHeadersService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: ResponseHeadersInterceptor,
            multi   : true
        }
    ]
})
export class ResponseHeadersModule
{
}
